export enum DifficultyLevel {
  Junior = 0,
  Medior = 1,
  Senior = 2,
}
